import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const SignUpComponent = lazy(() =>
  import(
    /* webpackChunkName: "SignUpComponent" */ "../components/SignUpComponent/SignUpComponent"
  )
);

// Redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function signup(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Signup - Content Generator`}
        description={`Join Content Generator today and start creating professional marketing content. Get access to powerful post creation tools and scheduling automation.`}
        url={`https://contentgenerator.io/signup`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <SignUpComponent />
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps)(signup);
